import React, { useCallback } from 'react';
import cn from 'classnames';

import IMG_SLICK from 'assets/images/logos/slick-logo-text.png';
import validateEmail from 'bl/validation/validateEmail.bl';
import Button from 'components/form/Button.component';
import FormField from 'components/form/FormField.component';
import TextInput from 'components/form/TextInput.component';
import S from 'constants/string.const';
import useStateWhileMounted from 'hooks/useStateWhileMounted.hook';
import useTip from 'hooks/useTip.hook';
import fromAnyToTrimmed from 'utils/converters/any/fromAnyToTrimmed.util';
import call from 'utils/functions/call.util';

import { normalizeEmail } from 'lib/normalize';

import CN from './EmailPanel.module.scss';

const EmailPanel = ({ tag: tagFromProps, onNext }) => {
  const tag = fromAnyToTrimmed(tagFromProps);

  const [email, setEmail] = useStateWhileMounted(S.empty);

  const { inv: isNextDisabled, set: setIsEmailValid } = useTip(false);

  const handleValidate = useCallback(
    ({ trimmed }) => {
      const isValid = validateEmail({ value: trimmed });
      setIsEmailValid(isValid);
      setEmail(normalizeEmail(trimmed));
      return { error: isValid ? null : 'Please enter a valid email' };
    },
    [setEmail, setIsEmailValid],
  );

  const handleNext = useCallback(
    //
    () => void call('EmailPanel.onNext', onNext, { tag, email }),
    [email, onNext, tag],
  );

  const inputClasses = cn({
    [CN.inputContainer]: true,
    [CN.hasError]: isNextDisabled && fromAnyToTrimmed(email) !== '' && !validateEmail({ value: email }),
  });

  return (
    <div data-bem="EmailPanel" data-tag={tag} className={CN.component}>
      <img src={IMG_SLICK} alt="Slick logo" className={CN.logo} />
      <div className={CN.title}>
        Reset your <span className={CN.bold}>password</span> {S.key}
      </div>
      <div className={CN.subTitle}>
        Enter the email address you have used to setup your account and we will send you a 6 digit code to reset your
        password.
      </div>
      <div className={inputClasses}>
        <FormField
          input={TextInput}
          name="email"
          label="Email address"
          placeholder="you@example.com"
          onValidate={handleValidate}
          renderError="always"
        />
      </div>
      <div className={CN.buttonContainer}>
        <Button variant="primaryForce" width="max" height="max" onClick={handleNext} disabled={isNextDisabled}>
          <span className={CN.buttonFont}>SEND CODE</span>
        </Button>
      </div>
    </div>
  );
};

export default EmailPanel;
